import { useEffect, type ReactNode } from "react";

/**
 * H. Map & Timeline on a phone: the map owns the screen, and trip time is turned on a dial along
 * the bottom rather than hidden behind a sheet that has to be pulled up. Only the edges carry
 * anything — the trip's days above, the dial below, the recentre control in the corner — and the
 * map is never reduced to a strip.
 */
export function MapFullscreen({
  title,
  map,
  days,
  action,
  dial,
  children,
}: {
  /** Names the map for a screen reader; it is not drawn over the map. */
  title: string;
  map: ReactNode;
  /** The top edge: the trip's days, for crossing one in a tap instead of a long turn. */
  days?: ReactNode;
  /** Below the days on the right: the recentre control, when this phone knows where it is. */
  action?: ReactNode;
  /** The bottom edge: the time dial. */
  dial?: ReactNode;
  /** Anything that only mounts behind the map, such as the filter dialog. */
  children?: ReactNode;
}) {
  // The map owns the screen for as long as it is open; the page behind it does not scroll.
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);

  return (
    <section className="map-full" aria-label={title}>
      {map}
      {days}
      {action && <div className={`map-full-top${days ? " below-days" : ""}`}>{action}</div>}
      {dial}
      {children}
    </section>
  );
}
